<i18n lang='yml' src='../i18n/ShowSubLocation.yml'></i18n>
<template>
  <div>
    <div class="layout-tile">
      <div class="heading-block d-flex">
        <h4>
          <span class="program-name">{{subLocation.name[locale]}} {{$t('sub_location')}} </span>
        </h4>
        <a class='btn btn-sm btn-success ml-auto' :href="`${base_path}/${subLocation.id}/sittings`">                                         
          <font-awesome-icon :icon="['fa', 'pencil-alt']" />
          {{ $t('view_schedule') }}
        </a>
      </div>
      <div class="media-body">
        <h5 class="margin-top margin-bottom heading-page border-bottom">{{container_name}} - {{subLocation.name[locale]}}</h5>
        <div class="content-block">
          <div class="post-meta">
            <div class="action-bar border-bottom mb-4">
              <div class="btn-group btn-group-xs ml-auto" role="group">
                <a v-if="edit_permission == 'true'" class="btn btn-sm btn-outline-primary" :href="`${base_path}/${subLocation.id}/edit`">                                         
                  <font-awesome-icon :icon="['fa', 'pencil-alt']" />
                  {{ $t('edit') }}
                </a>

                <button class="dropdown-toggle btn btn-sm btn-outline-secondary" data-toggle="dropdown" href="#">
                  <span class="sr-only">dropdown-toggle</span>
                  <font-awesome-icon :icon="['fa', 'cog']"/>
                </button>

                <div class="dropdown-menu" role="navigation">
                  <a class="dropdown-item" :href="`${base_path}/${subLocation.id}/sittings`">
                    {{ $t('manage_sittings') }}
                  </a>
                  <a class="dropdown-item" :href="`${base_path}/${subLocation.id}/series`">
                    {{ $t('manage_series') }}
                  </a>
                </div>
              </div>
            </div>
            <ul class="exam-details my-3 border-bottom">
              <li class="row">
                <span class="status-bold col-sm-5 col-lg-4 col-xl-4">
                  {{$t('sub_location_id')}}
                </span>
                <span class="col-sm-6 col-xl-7">{{subLocation.sub_location_id}}</span> 
              </li>

              <li class="row">
                <span class="status-bold col-sm-5 col-lg-4 col-xl-4">
                  {{$t('name_en')}}
                </span>
                <span class="col-sm-6 col-xl-7">
                  {{subLocation.name.en}}
                </span>
              </li>

              <li class="row">
                <span class="status-bold col-sm-5 col-lg-4 col-xl-4">
                  {{$t('name_fr')}}
                </span>
                <span class="col-sm-6 col-xl-7">
                {{subLocation.name.fr}}
                </span>
              </li>

              <li class="row">
                <span class="status-bold col-sm-5 col-lg-4 col-xl-4">
                  {{$t('address')}}
                </span>
                <span class="col-sm-4 col-xl-7"
                >{{ formattedAddress}} </span>
                
              </li>

              <li class="row">
                <span class="status-bold col-sm-5 col-lg-4 col-xl-4">
                  {{$t('phone_number')}}
                </span>
                <span class="col-sm-6 col-xl-7">{{subLocation.phone_number}} </span>
                
              </li>

              <li class="row">
                <span class="status-bold col-sm-5 col-lg-4 col-xl-4">
                  {{$t('phone_number_extension')}}
                </span>
                <span class="col-sm-6 col-xl-7">{{subLocation.phone_number_extension ? subLocation.phone_number_extension: "N/A" }} </span>
                
              </li>

              <li class="row">
                <span class="status-bold col-sm-5 col-lg-4 col-xl-4">
                  {{$t('email')}}
                </span>
                <span class="col-sm-6 col-xl-7">{{subLocation.email}} </span>
              </li>

              <li class="row">
                <span class="status-bold col-sm-5 col-lg-4 col-xl-4">
                  {{$t('contact')}}
                </span>
                <span class="col-sm-6 col-xl-7">{{subLocation.contact}} </span>
                
              </li>
            </ul>
            <ul class="exam-details border-bottom my-3">

              <li class="row">
                <span class="status-bold col-sm-6 col-lg-5 col-xl-4">
                  {{$t('max_seats')}}
                </span>
                <span class="col-sm-6 col-xl-7"> 
                  {{subLocation.max_seats}} 
                </span>
              </li>

              <li class="row">
                <span class="status-bold col-sm-6 col-lg-5 col-xl-4">
                  {{$t('exam_booth_available')}}
                </span>
                <span class="col-sm-6 col-xl-7"> 
                  {{subLocation.exam_booth_available ? $t('yes_val') : $t('no_val')}} 
                </span>
              </li>

              <li class="row">
                <span class="status-bold col-sm-12 col-lg-5 col-xl-4">
                  {{$t('available_languages')}}
                </span>
                <span class="col-sm-12 col-xl-7"> 
                {{subLocation.available_languages}}
                </span>
              </li>
            </ul>
            <ul class="exam-details border-bottom my-3">

              <li class="row">
                <span class="status-bold col-sm-6 col-lg-5 col-xl-4">
                  {{$t('status')}}
                </span>
                <!-- <span class="col-sm-6 col-xl-7"> 
                  {{$t(subLocation.status)}}
                </span>            -->
              </li>
            </ul>
            <ul class="exam-details my-3">
              <li class="row">
                <span class="status-bold col-12">
                  {{$t('additional_information')}}
                </span>
                <template v-if="subLocation.additional_instructions">
                  <span class="col-12">{{subLocation.additional_instructions}}</span>
                  
                </template>
                <template v-else>
                  <span class="col-12">
                    {{ $t('no_instructions') }}
                  </span>
                </template>
              </li>

            </ul>
            <ul class="exam-details my-3">
              <li class="row">
                <span class="status-bold col-12">
                  {{$t('additional_information_fr')}}
                </span>
                <span class="col-12">
                  {{subLocation.additional_instructions_fr && subLocation.additional_instructions_fr.length > 0 ? subLocation.additional_instructions_fr : $t('no_instructions') }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import flash from '../../shared/flash_messages/components/Flash.vue'

  export default {
    props: ['locale', 'base_path', 'sub_location', 'container_name', 'edit_permission'],

    components: {
      flash
    },

    data() {
      return {
        subLocation: {
          name: {},
          sub_location_id: null,
          available_languages: null,
          phone_number: null,
          email: null,
          contact: null,
          addition_instructions: null,
          max_seats: null,
          status: null,
          exam_booth_available: null
        },
        formattedAddress: '',
        loading: false,
        error: false,
        filterParams: null,
        message_type: "",
        message_text: [],
        availableLanguages: [],
        statusData: []
      }
    },

    mounted() {
      this.$i18n.locale = this.locale;


      try{
        this.subLocation = JSON.parse(this.sub_location)
        this.createAddress()
      }
      catch(err) {
        this.error = true; 
      }
    },
    methods: {
      createAddress() {
        this.formattedAddress = `${this.subLocation['street_address']}, ${this.subLocation['city']}, ${this.subLocation['province']}, ${this.subLocation['postal_code']}`
      }
    }

 }
</script>
